import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
	progresso: { type: Number, required: true, default: 0 },
	hideInnerLabel: { type: Boolean, required: false, default: false },
	height: { type: String, required: false, default: 'h-4' },
	completedColor: { type: String, required: false, default: '' },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})